class Entity {
    element;
    x;
    y;
    offX;
    offY;
    pretransform = "";
    posttransform = "";
    lastTransform = "";
    constructor(x, y, parent, offX = "0px", offY = "0px") {
        this.x = x;
        this.y = y;
        this.offX = offX;
        this.offY = offY;
        this.element = document.createElement("div");
        parent.appendChild(this.element);
    }
    render(force = false) {
        let newTransform = this.pretransform + "translate(calc(" + this.x * stageWidth + "px + " + this.offX + "), calc(" + this.y * stageHeight + "px + " + this.offY + "))" + this.posttransform;
        if (newTransform != this.lastTransform || force) {
            this.element.style.transform = newTransform;
            this.lastTransform = newTransform;
        }
    }
    remove() {
        this.element.remove();
    }
}
function toData(perfs) {
    let ret = [];
    for (let i = 0; i < perfs.length; i++) {
        ret.push({ name: perfs[i].name, color: perfs[i].color, keyframes: perfs[i].keyframes });
    }
    return ret;
}
let onNonmoveClick = () => { };
function handleArrowClick(perf, e) {
    // e.stopPropagation(); //why was this here //it was to avoid dragging the elements like images //cant i use css for this //nope the draggable attribute though //nope //maybe this isnt the issue
    if (e.button == 0 && !shiftKeyDown) {
        if (selectedPieces.length == 0 || !selectedPieces.includes(perf)) {
            for (const p of selectedPieces) {
                p.element.classList.remove("selectedPiece");
            }
            selectedPieces = [perf];
            perf.element.classList.add("selectedPiece");
            perf.selectedX = perf.x * stageWidth;
            perf.selectedY = perf.y * stageHeight;
            let kf = perf.getCurrentKeyframeIndex();
            if (kf != -1) {
                perf.selectedCtrlX = perf.keyframes[kf].ctrlX;
                perf.selectedCtrlY = perf.keyframes[kf].ctrlY;
                perf.tempSelCtrlX = perf.keyframes[kf].ctrlX;
                perf.tempSelCtrlY = perf.keyframes[kf].ctrlY;
            }
            perf.selectedAngle = perf.rotation;
        }
        movingAngle = true;
        focusedPiece = perf;
    }
}
function handlePerformerClick(perf, e) {
    if (e.button == 0) {
        if (!piecesMovable) {
            onNonmoveClick(perf);
        }
        if (selectedPieces.length == 0) {
            selectedPieces = [perf];
            perf.element.classList.add("selectedPiece");
            movingAngle = false;
            perf.selectedX = perf.x * stageWidth;
            perf.selectedY = perf.y * stageHeight;
            let kf = perf.getCurrentKeyframeIndex();
            if (kf != -1) {
                perf.selectedCtrlX = perf.keyframes[kf].ctrlX;
                perf.selectedCtrlY = perf.keyframes[kf].ctrlY;
                perf.tempSelCtrlX = perf.keyframes[kf].ctrlX;
                perf.tempSelCtrlY = perf.keyframes[kf].ctrlY;
            }
            perf.selectedAngle = perf.rotation;
        }
        else if (!selectedPieces.includes(perf) && shiftKeyDown) {
            selectedPieces.push(perf);
            perf.element.classList.add("selectedPiece");
            movingAngle = false;
            perf.selectedX = perf.x * stageWidth;
            perf.selectedY = perf.y * stageHeight;
            let kf = perf.getCurrentKeyframeIndex();
            if (kf != -1) {
                perf.selectedCtrlX = perf.keyframes[kf].ctrlX;
                perf.selectedCtrlY = perf.keyframes[kf].ctrlY;
                perf.tempSelCtrlX = perf.keyframes[kf].ctrlX;
                perf.tempSelCtrlY = perf.keyframes[kf].ctrlY;
            }
            perf.selectedAngle = perf.rotation;
        }
    }
    else if (e.button == 2) {
        //TODO idk man adding new keyframes doesnt work or something
        let i = perf.getCurrentKeyframeIndex();
        if (i == -1) {
            let last = perf.getPreviousKeyframe(+timelineElement.value);
            let next = perf.getNextKeyframe(+timelineElement.value);
            if (last && next) {
                let circ = fitCircleToPoints(last.x * stageWidth, last.y * stageHeight, next.ctrlX * stageWidth, next.ctrlY * stageHeight, next.x * stageWidth, next.y * stageHeight);
                if (circ && !(last.x == next.x && last.y == next.y)) {
                    let dist = Math.sqrt((perf.x * stageWidth - circ.x) * (perf.x * stageWidth - circ.x) + (perf.y * stageHeight - circ.y) * (perf.y * stageHeight - circ.y));
                    if (Math.abs(dist - circ.radius) < snapRadius) { //this should probably not be equal the snap radius (its in pixels)
                        let a1 = Math.atan2(last.y * stageHeight - circ.y, last.x * stageWidth - circ.x);
                        let an = Math.atan2(perf.y * stageHeight - circ.y, perf.x * stageWidth - circ.x);
                        let a2 = Math.atan2(next.y * stageHeight - circ.y, next.x * stageWidth - circ.x);
                        if (!circ.CCW && a2 < a1) {
                            a2 += Math.PI * 2;
                        }
                        else if (circ.CCW && a2 > a1) {
                            a2 -= Math.PI * 2;
                        }
                        if (!circ.CCW && an < a1) {
                            an += Math.PI * 2;
                        }
                        else if (circ.CCW && an > a1) {
                            an -= Math.PI * 2;
                        }
                        let currCtrlA = (a1 + an) / 2;
                        let nextCtrlA = (an + a2) / 2;
                        let currCtrlX = (Math.cos(currCtrlA) * circ.radius + circ.x) / stageWidth;
                        let currCtrlY = (Math.sin(currCtrlA) * circ.radius + circ.y) / stageHeight;
                        let nextCtrlX = (Math.cos(nextCtrlA) * circ.radius + circ.x) / stageWidth;
                        let nextCtrlY = (Math.sin(nextCtrlA) * circ.radius + circ.y) / stageHeight;
                        perf.setKeyframe({ x: perf.x, y: perf.y, ctrlX: currCtrlX, ctrlY: currCtrlY, a: perf.rotation, t: +timelineElement.value });
                        let oldNext = copyPos(next);
                        next.ctrlX = nextCtrlX;
                        next.ctrlY = nextCtrlY;
                        addToHistory({ newPos: copyPos(next), oldPos: oldNext, subject: perf, silent: true });
                    }
                    else {
                        //just set up lines
                        perf.setKeyframe({ x: perf.x, y: perf.y, ctrlX: (perf.x + last.x) / 2, ctrlY: (perf.y + last.y) / 2, a: perf.rotation, t: +timelineElement.value });
                        let oldNext = copyPos(next);
                        next.ctrlX = (perf.x + next.x) / 2;
                        next.ctrlY = (perf.y + next.y) / 2;
                        addToHistory({ newPos: copyPos(next), oldPos: oldNext, subject: perf, silent: true });
                    }
                }
                else {
                    perf.setKeyframe({ x: perf.x, y: perf.y, ctrlX: (perf.x + last.x) / 2, ctrlY: (perf.y + last.y) / 2, a: perf.rotation, t: +timelineElement.value });
                    let oldNext = copyPos(next);
                    next.ctrlX = (perf.x + next.x) / 2;
                    next.ctrlY = (perf.y + next.y) / 2;
                    addToHistory({ newPos: copyPos(next), oldPos: oldNext, subject: perf, silent: true });
                }
            }
            else if (last) {
                perf.setKeyframe({ x: perf.x, y: perf.y, ctrlX: (perf.x + last.x) / 2, ctrlY: (perf.y + last.y) / 2, a: perf.rotation, t: +timelineElement.value });
                //adding new last keyframe does not need to affect ctrls of the next frame for obvious reasons
            }
            else if (next) {
                perf.setKeyframe({ x: perf.x, y: perf.y, ctrlX: perf.x, ctrlY: perf.y, a: perf.rotation, t: +timelineElement.value });
                let oldNext = copyPos(next);
                next.ctrlX = (perf.x + next.x) / 2;
                next.ctrlY = (perf.y + next.y) / 2;
                addToHistory({ newPos: copyPos(next), oldPos: oldNext, subject: perf, silent: true });
            }
            else {
                console.error("how did you get here. perf is not good. performer had no keyframes");
            }
        }
        else {
            //TODO this shits the bed if multiselect is in use, and really should apply to all selected
            perf.temporarilyMoved = true;
            perf.selectedX = perf.keyframes[i].x;
            perf.selectedY = perf.keyframes[i].y;
            perf.selectedAngle = perf.keyframes[i].a;
            perf.selectedCtrlX = perf.keyframes[i].ctrlX;
            perf.selectedCtrlY = perf.keyframes[i].ctrlY;
            perf.tempSelCtrlX = perf.keyframes[i].ctrlX;
            perf.tempSelCtrlY = perf.keyframes[i].ctrlY;
            perf.removeKeyframe(i);
        }
    }
}
export class Performer extends Entity {
    nameElement;
    arrowElement;
    name;
    keyframes; //should always be in order of increasing t
    temporarilyMoved = false;
    rotation; //in degrees
    lastColor = "";
    lastTextColor = "";
    lastArrowTransform = "";
    color = "";
    highlightColor = "";
    textColor = "";
    selectedX = 0;
    selectedY = 0;
    selectedCtrlX = 0;
    selectedCtrlY = 0;
    selectedAngle = 0;
    tempSelCtrlX = 0;
    tempSelCtrlY = 0;
    premovePos;
    constructor(x, y, name, color) {
        super(x, y, stageElement, "-2.1vh - 2px", "-2.1vh - 2px");
        this.name = name;
        if (color && color.length > 0) {
            this.setColor(color);
        }
        else {
            this.color = "#8FC73E";
            this.setColor("#8FC73E");
        }
        this.rotation = 0;
        this.nameElement = document.createElement("div");
        this.nameElement.textContent = this.name;
        this.nameElement.className = "pieceName";
        // this.nameElement.draggable = false;
        this.arrowElement = document.createElement("div");
        this.arrowElement.className = "arrow";
        // this.arrowElement.draggable = false;
        this.element.appendChild(this.arrowElement);
        this.element.appendChild(this.nameElement);
        this.element.classList.add("stagePiece");
        // this.element.draggable = false;
        this.arrowElement.onmousedown = (e) => handleArrowClick(this, e);
        this.element.onmousedown = (e) => handlePerformerClick(this, e);
        this.keyframes = [];
        this.keyframes[0] = { x: x, y: y, ctrlX: x, ctrlY: y, a: 0, t: 0 };
        this.premovePos = { x: x, y: y, ctrlX: x, ctrlY: y, a: 0, t: 0 };
    }
    addToDOM() {
        // let pos = this.getPos(+timelineElement.value);
        // this.x = pos.x;
        // this.y = pos.y;
        this.element = document.createElement("div");
        stageElement.appendChild(this.element);
        this.nameElement = document.createElement("div");
        this.nameElement.textContent = this.name;
        this.nameElement.className = "pieceName";
        // this.nameElement.draggable = false;
        this.arrowElement = document.createElement("div");
        this.arrowElement.className = "arrow";
        // this.arrowElement.draggable = false;
        this.element.appendChild(this.arrowElement);
        this.element.appendChild(this.nameElement);
        this.element.classList.add("stagePiece");
        // this.element.draggable = false;
        this.arrowElement.onmousedown = (e) => handleArrowClick(this, e);
        this.element.onmousedown = (e) => handlePerformerClick(this, e);
    }
    getCurrentKeyframeIndex(t = +timelineElement.value) {
        for (let i = 0; i < this.keyframes.length; i++) {
            if (this.keyframes[i].t == t) {
                return i;
            }
        }
        return -1;
    }
    removeKeyframe(index, suppressHistory = false) {
        if (this.keyframes.length <= 1) {
            return;
        }
        if (!suppressHistory) {
            addToHistory({ oldPos: copyPos(this.keyframes[index]), newPos: null, subject: this });
        }
        this.keyframes.splice(index, 1);
    }
    setKeyframe(keyframe, suppressHistory = false) {
        for (let i = 0; i < this.keyframes.length; i++) {
            if (this.keyframes[i].t > keyframe.t) {
                if (!suppressHistory) {
                    addToHistory({ oldPos: null, newPos: copyPos(keyframe), subject: this });
                }
                this.keyframes.splice(i, 0, keyframe);
                this.temporarilyMoved = false;
                return;
            }
            else if (this.keyframes[i].t == keyframe.t) {
                this.keyframes[i] = keyframe;
                return;
            }
        }
        if (!suppressHistory) {
            addToHistory({ oldPos: null, newPos: copyPos(keyframe), subject: this });
        }
        this.keyframes.push(keyframe);
        this.temporarilyMoved = false;
    }
    getPos(t) {
        for (let i = 0; i < this.keyframes.length; i++) {
            if (this.keyframes[i].t > t) {
                if (i == 0) {
                    return this.keyframes[0];
                }
                else {
                    let p1 = this.keyframes[i - 1];
                    let p2 = this.keyframes[i];
                    let scalar = (t - p1.t) / (p2.t - p1.t);
                    if (p1.x == p2.x && p1.y == p2.y) {
                        return { x: p1.x, y: p1.y, ctrlX: p2.ctrlX, ctrlY: p2.ctrlY, a: p1.a + (p2.a - p1.a) * scalar, t: t };
                    }
                    let circ = fitCircleToPoints(p1.x * stageWidth, p1.y * stageHeight, p2.ctrlX * stageWidth, p2.ctrlY * stageHeight, p2.x * stageWidth, p2.y * stageHeight);
                    if (circ) {
                        let a1 = Math.atan2(p1.y * stageHeight - circ.y, p1.x * stageWidth - circ.x);
                        let a2 = Math.atan2(p2.y * stageHeight - circ.y, p2.x * stageWidth - circ.x);
                        if (!circ.CCW && a2 < a1) {
                            a2 += Math.PI * 2;
                        }
                        else if (circ.CCW && a2 > a1) {
                            a2 -= Math.PI * 2;
                        }
                        let ox = (Math.cos(a1 + (a2 - a1) * scalar) * circ.radius + circ.x) / stageWidth;
                        let oy = (Math.sin(a1 + (a2 - a1) * scalar) * circ.radius + circ.y) / stageHeight;
                        return { x: ox, y: oy, ctrlX: p2.ctrlX, ctrlY: p2.ctrlY, a: p1.a + (p2.a - p1.a) * scalar, t: t };
                    }
                    else {
                        return { x: p1.x + (p2.x - p1.x) * scalar, y: p1.y + (p2.y - p1.y) * scalar, ctrlX: p2.ctrlX, ctrlY: p2.ctrlY, a: p1.a + (p2.a - p1.a) * scalar, t: t };
                    }
                }
            }
            else if (this.keyframes[i].t == t) {
                return this.keyframes[i];
            }
        }
        return this.keyframes[this.keyframes.length - 1];
    }
    getPreviousKeyframe(t) {
        //assumes keyframes are stored in order (they sure should be)
        for (let i = this.keyframes.length - 1; i >= 0; i--) {
            if (this.keyframes[i].t < t) {
                return this.keyframes[i];
            }
        }
        return null;
    }
    getNextKeyframe(t) {
        //assumes keyframes are stored in order (they sure should be)
        for (let i = 0; i < this.keyframes.length; i++) {
            if (this.keyframes[i].t > t) {
                return this.keyframes[i];
            }
        }
        return null;
    }
    setName(name) {
        this.name = name;
        this.nameElement.textContent = name;
    }
    setColor(color, textColor = "") {
        this.color = color;
        let r = parseInt(color.slice(1, 3), 16) / 255;
        let g = parseInt(color.slice(3, 5), 16) / 255;
        let b = parseInt(color.slice(5, 7), 16) / 255;
        this.highlightColor = "#" + Math.ceil((r + 4) / 5 * 255).toString(16) + Math.ceil((g + 4) / 5 * 255).toString(16) + Math.ceil((b + 4) / 5 * 255).toString(16);
        if (textColor == "") {
            let lum = 0.299 * r * r + 0.587 * g * g + 0.114 * b * b;
            this.textColor = lum < 0.6 ? "#ffffff" : "#000000";
        }
        else {
            this.textColor = textColor;
        }
    }
    update() {
        if (selectedPieces.includes(this) && piecesMovable) {
            this.temporarilyMoved = true;
            if (movingAngle) {
            }
            else {
                if (this.x < 0) {
                    this.x = 0;
                }
                if (this.x > 1) {
                    this.x = 1;
                }
                if (this.y < 0) {
                    this.y = 0;
                }
                if (this.y > 1) {
                    this.y = 1;
                }
            }
        }
        else if (!this.temporarilyMoved) {
            let pos = this.getPos(+timelineElement.value);
            this.x = pos.x;
            this.y = pos.y;
            this.rotation = pos.a;
            this.premovePos.x = this.x;
            this.premovePos.y = this.y;
            this.premovePos.a = this.rotation;
        }
    }
    render(force = false) {
        super.render(force);
        let newColor = (this.getCurrentKeyframeIndex() == -1 || !piecesMovable) ? this.color : this.highlightColor;
        let newTextColor = (this.getCurrentKeyframeIndex() == -1 || !piecesMovable) ? this.textColor : "#000000";
        let newArrowTransform = "translate(-50%, -50%) rotate(" + (this.temporarilyMoved ? this.selectedAngle : this.rotation) + "deg) translate(0, -1.7em)";
        if (newColor != this.lastColor || force) {
            this.element.style.backgroundColor = newColor;
            this.lastColor = newColor;
        }
        if (newTextColor != this.lastTextColor || force) {
            this.nameElement.style.color = newTextColor;
            this.lastTextColor = newTextColor;
        }
        if (newArrowTransform != this.lastArrowTransform || force) {
            this.arrowElement.style.transform = newArrowTransform;
            this.lastArrowTransform = newArrowTransform;
        }
    }
}
const stageElement = document.querySelector("#stageBackground");
const stageDeco = document.querySelector("#stageDecorations");
const ctx = stageDeco.getContext("2d");
const timelineElement = document.querySelector("#timeline");
let stagePieces = [];
let selectedPieces = [];
let selectedControlPointPerf = -1;
let movingAngle = false;
let focusedPiece = null;
let timelineInControl = false;
let ctrlKeyDown = false;
let shiftKeyDown = false;
let mouse0Down = false;
export let currentSet;
let snapRadius = 10;
let stageWidth = stageElement.clientWidth;
let stageHeight = stageElement.clientHeight;
new ResizeObserver(() => { stageWidth = stageElement.clientWidth; stageHeight = stageElement.clientHeight; }).observe(stageElement);
let music;
let piecesMovable = true;
let history = []; //use like a stack
let historyIndex = 0;
let actionQueue = []; //gets cleared every tick
function onTimelineMove(e) {
    timelineInControl = true;
    if (music)
        music.setTime(+timelineElement.value);
    for (let i = 0; i < stagePieces.length; i++) {
        stagePieces[i].temporarilyMoved = false;
    }
}
function clearScene() {
    for (let i = 0; i < stagePieces.length; i++) {
        stagePieces[i].remove();
    }
    stagePieces = [];
}
function lastKeyframe(time) {
    //resolution limited to 0.0001 of a second in order to prevent floating point error funnies
    let latest = null;
    for (let i = 0; i < stagePieces.length; i++) {
        let kf = stagePieces[i].getPreviousKeyframe(time - 0.0001);
        if (latest == null || (kf != null && kf.t > latest.t)) {
            latest = kf;
        }
    }
    return latest;
}
function nextKeyframe(time) {
    //resolution limited to 0.0001 of a second in order to prevent floating point error funnies
    let first = null;
    for (let i = 0; i < stagePieces.length; i++) {
        let kf = stagePieces[i].getNextKeyframe(time + 0.0001);
        if (first == null || (kf != null && kf.t < first.t)) {
            first = kf;
        }
    }
    return first;
}
function jumpToLastKeyframe() {
    let toFrame = lastKeyframe(music.getTime());
    let to = toFrame ? toFrame.t : 0;
    console.log("jumping last to " + to + " " + music.getTime());
    music.setTime(to);
    for (const p of selectedPieces) {
        p.element.classList.remove("selectedPiece");
    }
    selectedPieces = [];
    for (let i = 0; i < stagePieces.length; i++) {
        stagePieces[i].temporarilyMoved = false;
    }
}
function jumpToNextKeyframe() {
    let toFrame = nextKeyframe(music.getTime());
    let to = toFrame ? toFrame.t : music.getDuration() - 0.1;
    console.log("jumping next to " + to + " from " + music.getTime());
    music.setTime(to);
    for (const p of selectedPieces) {
        p.element.classList.remove("selectedPiece");
    }
    selectedPieces = [];
    for (let i = 0; i < stagePieces.length; i++) {
        stagePieces[i].temporarilyMoved = false;
    }
}
function copyPos(pos) {
    return { x: pos.x, y: pos.y, ctrlX: pos.ctrlX, ctrlY: pos.ctrlY, a: pos.a, t: pos.t };
}
function addToHistory(action) {
    //add checks idk
    actionQueue.push(action);
}
//returns whether this action was skipped and another should be undone
function undoAction(action) {
    if ("oldPos" in action) {
        if (action.newPos != null && action.oldPos != null) {
            if (action.newPos.t == -1) { //move on non keyframe
                if (action.oldPos.t == +timelineElement.value) {
                    action.subject.x = action.oldPos.x;
                    action.subject.y = action.oldPos.y;
                    action.subject.rotation = action.oldPos.a;
                }
                else {
                    return true;
                }
            }
            else {
                if (!action.silent)
                    music.setTime(action.newPos.t);
                let i = action.subject.getCurrentKeyframeIndex(action.newPos.t);
                action.subject.keyframes[i].x = action.oldPos.x;
                action.subject.keyframes[i].y = action.oldPos.y;
                action.subject.keyframes[i].ctrlX = action.oldPos.ctrlX;
                action.subject.keyframes[i].ctrlY = action.oldPos.ctrlY;
                action.subject.keyframes[i].a = action.oldPos.a;
                action.subject.temporarilyMoved = false;
            }
        }
        else if (action.newPos != null && action.oldPos == null) {
            if (!action.silent)
                music.setTime(action.newPos.t);
            let i = action.subject.getCurrentKeyframeIndex(action.newPos.t);
            action.subject.removeKeyframe(i, true);
        }
        else if (action.newPos == null && action.oldPos != null) {
            if (!action.silent)
                music.setTime(action.oldPos.t);
            action.subject.setKeyframe(copyPos(action.oldPos), true);
        }
        else {
            console.error("historical action with null old and new pos, something has gone wrong");
        }
    }
    else {
        if (action.added) { //we need to remove
            let i = stagePieces.indexOf(action.subject);
            stagePieces[i].element.remove();
            stagePieces.splice(i, 1);
        }
        else { //we need to add
            let perf = addExistingPerformer(action.subject);
            // perf.keyframes = action.subject.keyframes;
        }
    }
    return false;
}
//obviously action must have already been undid
function redoAction(action) {
    if ("oldPos" in action) { //normal action
        if (action.newPos != null && action.oldPos != null) {
            if (action.newPos.t == -1) { //move on non keyframe
                if (action.oldPos.t == +timelineElement.value) {
                    action.subject.x = action.newPos.x;
                    action.subject.y = action.newPos.y;
                    action.subject.rotation = action.newPos.a;
                }
                else {
                    return true;
                }
            }
            else {
                if (!action.silent)
                    music.setTime(action.oldPos.t);
                let i = action.subject.getCurrentKeyframeIndex(action.oldPos.t);
                action.subject.keyframes[i].x = action.newPos.x;
                action.subject.keyframes[i].y = action.newPos.y;
                action.subject.keyframes[i].ctrlX = action.newPos.ctrlX;
                action.subject.keyframes[i].ctrlY = action.newPos.ctrlY;
                action.subject.keyframes[i].a = action.newPos.a;
                action.subject.temporarilyMoved = false;
            }
        }
        else if (action.newPos != null && action.oldPos == null) {
            if (!action.silent)
                music.setTime(action.newPos.t);
            action.subject.setKeyframe(copyPos(action.newPos), true);
        }
        else if (action.newPos == null && action.oldPos != null) {
            if (!action.silent)
                music.setTime(action.oldPos.t);
            let i = action.subject.getCurrentKeyframeIndex(action.oldPos.t);
            action.subject.removeKeyframe(i, true);
        }
        else {
            console.error("historical action with null old and new pos, something has gone wrong");
        }
    }
    else { //araction
        if (action.added) { //we need to add
            let perf = addExistingPerformer(action.subject);
        }
        else { //we need to remove
            let i = stagePieces.indexOf(action.subject);
            stagePieces[i].element.remove();
            stagePieces.splice(i, 1);
        }
    }
    return false;
}
function undo() {
    if (historyIndex > 0) {
        historyIndex--;
        for (let action of history[historyIndex]) {
            if (undoAction(action)) {
                undo();
            }
        }
    }
}
function redo() {
    if (historyIndex < history.length) {
        historyIndex++;
        for (let action of history[historyIndex]) {
            if (redoAction(action)) {
                redo();
            }
        }
    }
}
export function addPerformer(x, y, name, color, suppressHistory = false) {
    let perf = new Performer(x, y, name, color);
    let pos = { x: x, y: y, ctrlX: x, ctrlY: y, a: 0, t: 0 };
    perf.keyframes = [pos];
    stagePieces.push(perf);
    if (!suppressHistory)
        addToHistory({ subject: perf, added: true });
    return perf;
}
//does not add to history because should only be used for undo and redo
function addExistingPerformer(perf) {
    perf.addToDOM();
    perf.render(true);
    stagePieces.push(perf);
    console.log(perf.element);
    return perf;
}
export function removePerformer(perf) {
    let i = stagePieces.indexOf(perf);
    stagePieces[i].element.remove();
    stagePieces.splice(i, 1);
    addToHistory({ subject: perf, added: false });
}
function setScene(set) {
    clearScene();
    console.log(set);
    let ps = JSON.parse(set.choreoJson);
    const stage = document.querySelector("#stageBackground");
    for (let i = 0; i < ps.length; i++) {
        let perf = new Performer(ps[i].keyframes[0].x, ps[i].keyframes[0].y, ps[i].name, ps[i].color);
        perf.keyframes = ps[i].keyframes;
        stagePieces.push(perf);
    }
}
function playPause() {
    let button = document.querySelector("#playPause");
    if (button.className == "playButton") {
        button.className = "pauseButton";
    }
    else {
        button.className = "playButton";
    }
    music.shitFunction();
}
export function setTimelineDuration(duration) {
    let timeEnd = document.querySelector("#timeEnd");
    timelineElement.max = "" + duration;
    timeEnd.textContent = Math.floor(duration / 60) + ":" + String(Math.floor(duration) % 60).padStart(2, "0");
}
export function setPiecesMovable(movable) {
    piecesMovable = movable;
}
export function setMusic(m) {
    music = m;
}
export function saveChoreo() {
    let req = new XMLHttpRequest();
    req.open("POST", "/auth/bcs/save/", true);
    req.setRequestHeader("Content-type", "application/json");
    req.onreadystatechange = () => {
        if (req.readyState == 4 && req.status == 200) {
            console.log("Set saved successfully");
        }
    };
    currentSet.choreoJson = JSON.stringify(toData(stagePieces));
    req.send(JSON.stringify(currentSet));
}
export function forEachPiece(fe) {
    stagePieces.forEach(fe);
}
export function resetScene() {
    clearScene();
    stagePieces.push(new Performer(0.5, 0.2, "Alec", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 0 / 13, 0.5, "Cade", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 1 / 13, 0.5, "Sean", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 2 / 13, 0.5, "Brandon", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 3 / 13, 0.5, "Neil", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 4 / 13, 0.5, "Charlie", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 5 / 13, 0.5, "Matt", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 6 / 13, 0.5, "Will", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 7 / 13, 0.5, "Caleb", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 8 / 13, 0.5, "Peter", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 9 / 13, 0.5, "Sam", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 10 / 13, 0.5, "Atria", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 11 / 13, 0.5, "Jung", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 12 / 13, 0.5, "Rowan", "#8FC73E"));
    stagePieces.push(new Performer(0.1 + 0.8 * 13 / 13, 0.5, "Adam", "#8FC73E"));
}
export function initChoreo(onNoneditPieceClick = () => { }, onDone = () => { }) {
    onNonmoveClick = onNoneditPieceClick;
    document.querySelector("body").onmousemove = (e) => {
        if (selectedPieces.length > 0 && piecesMovable && mouse0Down && !shiftKeyDown) {
            for (const selectedPiece of selectedPieces) {
                if (movingAngle) {
                    let selectedBound = focusedPiece ? focusedPiece.element.getBoundingClientRect() : selectedPiece.element.getBoundingClientRect();
                    let inAngle = Math.atan2(e.clientY - (selectedBound.y + selectedBound.height / 2), e.clientX - (selectedBound.x + selectedBound.width / 2)) * 180 / 3.14159 + 90;
                    let keyframe = selectedPiece.getCurrentKeyframeIndex();
                    if (keyframe != -1) {
                        let norm = selectedPiece.selectedAngle % 360;
                        norm = (norm + 360) % 360;
                        if (norm > 180)
                            norm -= 360;
                        let diff = (inAngle - norm + 180) % 360 - 180;
                        diff = diff < -180 ? diff + 360 : diff;
                        selectedPiece.selectedAngle += diff;
                    }
                }
                else {
                    selectedPiece.selectedX += e.movementX;
                    selectedPiece.selectedY += e.movementY;
                }
            }
        }
        else if (selectedControlPointPerf != -1) {
            let ref = stagePieces[selectedControlPointPerf].getCurrentKeyframeIndex();
            if (ref != -1) {
                stagePieces[selectedControlPointPerf].tempSelCtrlX += e.movementX / stageWidth;
                stagePieces[selectedControlPointPerf].tempSelCtrlY += e.movementY / stageHeight;
                if (ref > 0) {
                    let x0 = stagePieces[selectedControlPointPerf].tempSelCtrlX * stageWidth;
                    let y0 = stagePieces[selectedControlPointPerf].tempSelCtrlY * stageHeight;
                    let x1 = stagePieces[selectedControlPointPerf].keyframes[ref - 1].x * stageWidth;
                    let y1 = stagePieces[selectedControlPointPerf].keyframes[ref - 1].y * stageHeight;
                    let x2 = stagePieces[selectedControlPointPerf].keyframes[ref].x * stageWidth;
                    let y2 = stagePieces[selectedControlPointPerf].keyframes[ref].y * stageHeight;
                    let nom = Math.abs((y2 - y1) * x0 - (x2 - x1) * y0 + x2 * y1 - y2 * x1);
                    let denom = Math.sqrt((y2 - y1) * (y2 - y1) + (x2 - x1) * (x2 - x1));
                    let dist = nom / denom;
                    if (dist < snapRadius) {
                        let nx = (x2 - x1) / denom;
                        let ny = (y2 - y1) / denom;
                        let dot = nx * (x0 - x1) + ny * (y0 - y1);
                        let dx = dot * nx;
                        let dy = dot * ny;
                        stagePieces[selectedControlPointPerf].selectedCtrlX = (x1 + dx) / stageWidth;
                        stagePieces[selectedControlPointPerf].selectedCtrlY = (y1 + dy) / stageHeight;
                    }
                    else {
                        stagePieces[selectedControlPointPerf].selectedCtrlX = stagePieces[selectedControlPointPerf].tempSelCtrlX;
                        stagePieces[selectedControlPointPerf].selectedCtrlY = stagePieces[selectedControlPointPerf].tempSelCtrlY;
                    }
                }
            }
            else {
                console.log("how did you get here");
                selectedControlPointPerf = -1;
            }
        }
    };
    document.querySelector("body").onmousedown = (e) => {
        if (e.button == 0) {
            mouse0Down = true;
        }
    };
    document.querySelector("body").onmouseup = (e) => {
        if (e.button == 0) {
            mouse0Down = false;
            focusedPiece = null;
        }
        for (let p of selectedPieces) {
            let kf = p.getCurrentKeyframeIndex();
            if (Math.abs(p.premovePos.x - p.x) > 0.0001 || Math.abs(p.premovePos.y - p.y) > 0.0001) {
                console.log("fucking move");
                if (kf == -1) {
                    addToHistory({ subject: p,
                        oldPos: { x: p.premovePos.x, y: p.premovePos.y, a: p.premovePos.a, t: +timelineElement.value, ctrlX: p.premovePos.ctrlX, ctrlY: p.premovePos.ctrlY },
                        newPos: { x: p.x, y: p.y, a: p.rotation, t: -1, ctrlX: 0, ctrlY: 0 } });
                    p.premovePos.x = p.x;
                    p.premovePos.y = p.y;
                }
                else {
                    //record old keyframe
                    let oldPos = copyPos(p.keyframes[kf]);
                    //update keyframe
                    p.keyframes[kf].x = p.selectedX / stageWidth;
                    p.keyframes[kf].y = p.selectedY / stageHeight;
                    p.keyframes[kf].ctrlX = p.selectedCtrlX;
                    p.keyframes[kf].ctrlY = p.selectedCtrlY;
                    let newPos = copyPos(p.keyframes[kf]);
                    addToHistory({
                        subject: p,
                        oldPos: oldPos,
                        newPos: newPos
                    });
                    p.premovePos = copyPos(p.keyframes[kf]);
                }
            }
            else if (Math.abs(p.premovePos.a - p.selectedAngle) > 0.0001) {
                p.rotation = p.selectedAngle;
                if (kf == -1) {
                    addToHistory({ subject: p,
                        oldPos: { x: p.premovePos.x, y: p.premovePos.y, a: p.premovePos.a, t: +timelineElement.value, ctrlX: p.premovePos.ctrlX, ctrlY: p.premovePos.ctrlY },
                        newPos: { x: p.x, y: p.y, a: p.rotation, t: -1, ctrlX: 0, ctrlY: 0 } });
                    p.premovePos.a = p.selectedAngle;
                }
                else {
                    //record old keyframe
                    let oldPos = copyPos(p.keyframes[kf]);
                    //update keyframe
                    p.keyframes[kf].a = p.selectedAngle;
                    let newPos = copyPos(p.keyframes[kf]);
                    addToHistory({
                        subject: p,
                        oldPos: oldPos,
                        newPos: newPos
                    });
                    p.premovePos = copyPos(p.keyframes[kf]);
                }
            }
        }
        if (selectedPieces.length == 1 && !shiftKeyDown) {
            for (const p of selectedPieces) {
                p.element.classList.remove("selectedPiece");
            }
            selectedPieces = [];
        }
        if (selectedControlPointPerf != -1) {
            let p = stagePieces[selectedControlPointPerf];
            let kf = p.getCurrentKeyframeIndex();
            if (kf != -1 && (Math.abs(p.premovePos.ctrlX - p.selectedCtrlX) > 0.0001 || Math.abs(p.premovePos.ctrlY - p.selectedCtrlY) > 0.0001)) {
                console.log("fucking control");
                p.temporarilyMoved = false;
                //record old keyframe
                let oldPos = copyPos(p.keyframes[kf]);
                //update keyframe
                p.keyframes[kf].ctrlX = p.selectedCtrlX;
                p.keyframes[kf].ctrlY = p.selectedCtrlY;
                let newPos = copyPos(p.keyframes[kf]);
                addToHistory({
                    subject: p,
                    oldPos: oldPos,
                    newPos: newPos
                });
                p.premovePos = copyPos(p.keyframes[kf]);
            }
        }
        selectedControlPointPerf = -1;
    };
    document.querySelector("body").onkeydown = (e) => {
        if (e.code == "PageUp") {
            jumpToNextKeyframe();
        }
        else if (e.code == "PageDown") {
            jumpToLastKeyframe();
        }
        else if (e.code == "Space") {
            playPause();
        }
        else if (e.code == "ControlLeft") {
            ctrlKeyDown = true;
        }
        else if (e.code == "ShiftLeft") {
            e.preventDefault();
            shiftKeyDown = true;
        }
        else if (e.code == "KeyZ" && ctrlKeyDown) {
            undo();
        }
        else if (e.code == "KeyY" && ctrlKeyDown) {
            redo();
        }
    };
    document.querySelector("body").onkeyup = (e) => {
        if (e.code == "ControlLeft") {
            ctrlKeyDown = false;
        }
        else if (e.code == "ShiftLeft") {
            e.preventDefault();
            shiftKeyDown = false;
        }
    };
    document.querySelector("#jumpFrwd").onclick = jumpToNextKeyframe;
    document.querySelector("#jumpBack").onclick = jumpToLastKeyframe;
    document.querySelector("#playPause").onclick = playPause;
    timelineElement.oninput = onTimelineMove;
    timelineElement.onkeydown = (e) => { e.preventDefault(); };
    stageElement.addEventListener('contextmenu', (e) => { e.preventDefault(); }, false);
    stageDeco.onmousedown = (e) => {
        if (!shiftKeyDown) {
            for (const p of selectedPieces) {
                p.element.classList.remove("selectedPiece");
            }
            selectedPieces = [];
        }
        for (let i = 0; i < stagePieces.length; i++) {
            let ref = stagePieces[i].getCurrentKeyframeIndex();
            if (ref != -1) {
                let frame = stagePieces[i].keyframes[ref];
                let distS = (e.offsetX / stageWidth - frame.ctrlX) * (e.offsetX / stageWidth - frame.ctrlX) + (e.offsetY / stageHeight - frame.ctrlY) * (e.offsetY / stageHeight - frame.ctrlY);
                if (distS < 0.015 * 0.015) {
                    selectedControlPointPerf = i;
                    // focusedPiece = i; not really what this is for now (its for multiselect rotations)
                    stagePieces[selectedControlPointPerf].selectedCtrlX = frame.ctrlX;
                    stagePieces[selectedControlPointPerf].selectedCtrlY = frame.ctrlY;
                    stagePieces[selectedControlPointPerf].tempSelCtrlX = frame.ctrlX;
                    stagePieces[selectedControlPointPerf].tempSelCtrlY = frame.ctrlY;
                    stagePieces[selectedControlPointPerf].selectedX = frame.x * stageWidth;
                    stagePieces[selectedControlPointPerf].selectedY = frame.y * stageHeight;
                    stagePieces[selectedControlPointPerf].selectedAngle = frame.a;
                    stagePieces[selectedControlPointPerf].temporarilyMoved = true;
                    console.log(stagePieces[i].name + " control point selected");
                }
            }
        }
    };
    let choreoId = 68;
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("choreoId")) {
        let strChoreoId = urlParams.get("choreoId");
        choreoId = strChoreoId == null ? 68 : +strChoreoId;
    }
    let getSet = new XMLHttpRequest();
    getSet.open("POST", "/auth/bcs/get/", true);
    getSet.setRequestHeader("Content-type", "application/json");
    getSet.onreadystatechange = () => {
        if (getSet.readyState == 4 && getSet.status == 200) {
            currentSet = JSON.parse(getSet.responseText);
            setScene(currentSet);
            console.log("Choreo Set " + currentSet.title + " loaded");
            document.title = currentSet.title;
            onDone();
        }
    };
    getSet.send(JSON.stringify({ choreoId: choreoId, ownerId: 0, title: "", choreoJson: "" }));
}
//thank you https://stackoverflow.com/questions/62550460/how-to-draw-a-curve-that-passes-three-points-in-canvas
function fitCircleToPoints(x1, y1, x2, y2, x3, y3) {
    let x, y, u;
    const slopeA = (x2 - x1) / (y1 - y2); // slope of vector from point 1 to 2
    const slopeB = (x3 - x2) / (y2 - y3); // slope of vector from point 2 to 3
    if (Math.abs(slopeA - slopeB) < 0.001) {
        return null;
    } // Slopes are same thus 3 points form striaght line. No circle can fit.
    if (y1 === y2) { // special case with points 1 and 2 have same y 
        x = ((x1 + x2) / 2);
        y = slopeB * x + (((y2 + y3) / 2) - slopeB * ((x2 + x3) / 2));
    }
    else if (y2 === y3) { // special case with points 2 and 3 have same y 
        x = ((x2 + x3) / 2);
        y = slopeA * x + (((y1 + y2) / 2) - slopeA * ((x1 + x2) / 2));
    }
    else {
        x = ((((y2 + y3) / 2) - slopeB * ((x2 + x3) / 2)) - (u = ((y1 + y2) / 2) - slopeA * ((x1 + x2) / 2))) / (slopeA - slopeB);
        y = slopeA * x + u;
    }
    return {
        x, y,
        radius: ((x1 - x) ** 2 + (y1 - y) ** 2) ** 0.5,
        CCW: ((x3 - x1) * (y2 - y1) - (y3 - y1) * (x2 - x1)) >= 0,
    };
}
export function update() {
    //update action history
    if (actionQueue.length > 0) {
        history.splice(historyIndex);
        history.push(actionQueue);
        historyIndex++;
        actionQueue = [];
        console.log(history);
    }
    if (selectedPieces.length > 0 && piecesMovable) {
        for (let selectedPiece of selectedPieces) {
            if (movingAngle) {
                // selectedPiece.rotation = selectedPiece.selectedAngle;
                // let keyframe = selectedPiece.getCurrentKeyframeIndex();
                // if(keyframe != -1) {
                //     let norm = selectedPiece.selectedAngle % 360;
                //     norm = (norm + 360) % 360;
                //     if (norm > 180)
                //         norm -= 360;
                //     let diff = ( selectedPiece.lastSelectedAngle - norm + 180 ) % 360 - 180;
                //     diff = diff < -180 ? diff + 360 : diff;
                //     selectedPiece.selectedAngle += diff;
                //     selectedPiece.lastSelectedAngle = selectedPiece.selectedAngle;
                // }
            }
            else {
                let lastX = selectedPiece.x;
                let lastY = selectedPiece.y;
                selectedPiece.x = selectedPiece.selectedX / stageWidth;
                selectedPiece.y = selectedPiece.selectedY / stageHeight;
                let keyframe = selectedPiece.getCurrentKeyframeIndex();
                if (keyframe != -1) {
                    // selectedPiece.keyframes[keyframe].x = selectedPiece.selectedX / stageWidth;
                    // selectedPiece.keyframes[keyframe].y = selectedPiece.selectedY / stageHeight;
                    if (keyframe > 0) {
                        if (lastX == selectedPiece.keyframes[keyframe - 1].x && lastY == selectedPiece.keyframes[keyframe - 1].y) {
                            selectedPiece.selectedCtrlX = (selectedPiece.x + selectedPiece.keyframes[keyframe - 1].x) / 2;
                            selectedPiece.selectedCtrlY = (selectedPiece.y + selectedPiece.keyframes[keyframe - 1].y) / 2;
                            selectedPiece.tempSelCtrlX = (selectedPiece.x + selectedPiece.keyframes[keyframe - 1].x) / 2;
                            selectedPiece.tempSelCtrlY = (selectedPiece.y + selectedPiece.keyframes[keyframe - 1].y) / 2;
                        }
                        else {
                            //move control points with it (idk if this is good to do)
                            let lastLineA = Math.atan2((selectedPiece.keyframes[keyframe - 1].y - lastY) * stageHeight, (selectedPiece.keyframes[keyframe - 1].x - lastX) * stageWidth);
                            let lastToCtrlA = Math.atan2((selectedPiece.selectedCtrlY - lastY) * stageHeight, (selectedPiece.selectedCtrlX - lastX) * stageWidth);
                            let lastLineLen = Math.sqrt(((selectedPiece.keyframes[keyframe - 1].y - lastY) * stageHeight) * ((selectedPiece.keyframes[keyframe - 1].y - lastY) * stageHeight) +
                                ((selectedPiece.keyframes[keyframe - 1].x - lastX) * stageWidth) * ((selectedPiece.keyframes[keyframe - 1].x - lastX) * stageWidth));
                            let lastToCtrlLen = Math.sqrt(((selectedPiece.selectedCtrlY - lastY) * stageHeight) * ((selectedPiece.selectedCtrlY - lastY) * stageHeight) +
                                ((selectedPiece.selectedCtrlX - lastX) * stageWidth) * ((selectedPiece.selectedCtrlX - lastX) * stageWidth));
                            let newLineA = Math.atan2((selectedPiece.keyframes[keyframe - 1].y - selectedPiece.y) * stageHeight, (selectedPiece.keyframes[keyframe - 1].x - selectedPiece.x) * stageWidth);
                            let newLineLen = Math.sqrt(((selectedPiece.keyframes[keyframe - 1].y - selectedPiece.y) * stageHeight) * ((selectedPiece.keyframes[keyframe - 1].y - selectedPiece.y) * stageHeight) +
                                ((selectedPiece.keyframes[keyframe - 1].x - selectedPiece.x) * stageWidth) * ((selectedPiece.keyframes[keyframe - 1].x - selectedPiece.x) * stageWidth));
                            let diffA = (newLineA - lastLineA + Math.PI) % (Math.PI * 2) - Math.PI;
                            diffA = diffA < -Math.PI ? diffA + (Math.PI * 2) : diffA;
                            let newToCtrlA = lastToCtrlA + diffA;
                            let newToCtrlLen = lastToCtrlLen * (newLineLen / lastLineLen);
                            selectedPiece.selectedCtrlX = (Math.cos(newToCtrlA) * newToCtrlLen + selectedPiece.x * stageWidth) / stageWidth;
                            selectedPiece.selectedCtrlY = (Math.sin(newToCtrlA) * newToCtrlLen + selectedPiece.y * stageHeight) / stageHeight;
                            selectedPiece.tempSelCtrlX = (Math.cos(newToCtrlA) * newToCtrlLen + selectedPiece.x * stageWidth) / stageWidth;
                            selectedPiece.tempSelCtrlY = (Math.sin(newToCtrlA) * newToCtrlLen + selectedPiece.y * stageHeight) / stageHeight;
                        }
                    }
                }
            }
        }
    }
    let musicTime = music.getTime();
    if (music.getDuration() > 0) {
        if (musicTime <= music.getDuration()) {
            timelineElement.value = "" + musicTime;
        }
        else {
            music.stopMusic();
            document.querySelector("#playPause").className = "playButton";
        }
    }
    let timeCurrent = document.querySelector("#timeCurrent");
    timeCurrent.textContent = Math.floor(musicTime / 60) + ":" + String(Math.floor(musicTime) % 60).padStart(2, "0");
    stagePieces.forEach(p => p.update());
    stagePieces.forEach(p => p.render());
    let width = stageElement.clientWidth;
    let height = stageElement.clientHeight;
    ctx.canvas.width = width;
    ctx.canvas.height = height;
    for (let i = 0; i < stagePieces.length; i++) {
        let ref = stagePieces[i].getCurrentKeyframeIndex();
        let curr = ref != -1 ? stagePieces[i].keyframes[ref] : stagePieces[i].getPos(musicTime);
        let last = stagePieces[i].getPreviousKeyframe(curr.t);
        let next = stagePieces[i].getNextKeyframe(curr.t);
        if (ctrlKeyDown && curr && next && ref != -1) {
            if (curr.x != next.x || curr.y != next.y) {
                let circ = fitCircleToPoints(curr.x * width, curr.y * height, next.ctrlX * width, next.ctrlY * height, next.x * width, next.y * height);
                ctx.strokeStyle = "#000000";
                ctx.setLineDash([10, 10]);
                ctx.lineWidth = 3;
                if (circ) {
                    ctx.beginPath();
                    ctx.arc(circ.x, circ.y, circ.radius, Math.atan2(curr.y * height - circ.y, curr.x * width - circ.x), Math.atan2(next.y * height - circ.y, next.x * width - circ.x), circ.CCW);
                    ctx.stroke();
                }
                else {
                    ctx.beginPath();
                    ctx.moveTo(curr.x * width, curr.y * height);
                    ctx.lineTo(next.x * width, next.y * height);
                    ctx.stroke();
                }
            }
        }
        if (last && curr) {
            if (last.a != curr.a) {
                ctx.strokeStyle = "#000000";
                ctx.setLineDash([4, 4]);
                ctx.lineWidth = 3;
                ctx.beginPath();
                if (stagePieces[i].temporarilyMoved) {
                    ctx.arc(stagePieces[i].x * width, stagePieces[i].y * height, window.innerHeight * 0.03, last.a * Math.PI / 180 - Math.PI / 2, stagePieces[i].selectedAngle * Math.PI / 180 - Math.PI / 2, stagePieces[i].selectedAngle < last.a);
                }
                else {
                    ctx.arc(stagePieces[i].x * width, stagePieces[i].y * height, window.innerHeight * 0.03, last.a * Math.PI / 180 - Math.PI / 2, curr.a * Math.PI / 180 - Math.PI / 2, curr.a < last.a);
                }
                ctx.stroke();
            }
            if (last.x != curr.x || last.y != curr.y) {
                if (ref != -1) {
                    let cx = stagePieces[i].temporarilyMoved ? (stagePieces[i].selectedCtrlX * width) : (curr.ctrlX * width);
                    let cy = stagePieces[i].temporarilyMoved ? (stagePieces[i].selectedCtrlY * height) : (curr.ctrlY * height);
                    let px = stagePieces[i].temporarilyMoved ? (stagePieces[i].selectedX) : (curr.x * width);
                    let py = stagePieces[i].temporarilyMoved ? (stagePieces[i].selectedY) : (curr.y * height);
                    let circ = fitCircleToPoints(last.x * width, last.y * height, cx, cy, px, py);
                    ctx.strokeStyle = "#000000";
                    ctx.setLineDash([10, 10]);
                    ctx.lineWidth = 3;
                    if (circ) {
                        ctx.beginPath();
                        ctx.arc(circ.x, circ.y, circ.radius, Math.atan2(last.y * height - circ.y, last.x * width - circ.x), Math.atan2(py - circ.y, px - circ.x), circ.CCW);
                        ctx.stroke();
                    }
                    else {
                        ctx.beginPath();
                        ctx.moveTo(last.x * width, last.y * height);
                        ctx.lineTo(px, py);
                        ctx.stroke();
                    }
                }
                else if (next) {
                    let circ = fitCircleToPoints(last.x * width, last.y * height, next.ctrlX * width, next.ctrlY * height, next.x * width, next.y * height);
                    ctx.strokeStyle = "#000000";
                    ctx.setLineDash([10, 10]);
                    ctx.lineWidth = 3;
                    if (circ) {
                        ctx.beginPath();
                        ctx.arc(circ.x, circ.y, circ.radius, Math.atan2(last.y * height - circ.y, last.x * width - circ.x), Math.atan2(curr.y * height - circ.y, curr.x * width - circ.x), circ.CCW);
                        ctx.stroke();
                    }
                    else {
                        ctx.beginPath();
                        ctx.moveTo(last.x * width, last.y * height);
                        ctx.lineTo(curr.x * width, curr.y * height);
                        ctx.stroke();
                    }
                }
                if (ref != -1) {
                    ctx.fillStyle = "#ffffff";
                    ctx.setLineDash([]);
                    ctx.beginPath();
                    if (stagePieces[i].temporarilyMoved) {
                        ctx.arc(stagePieces[i].selectedCtrlX * width, stagePieces[i].selectedCtrlY * height, height * 0.015, 0, 2 * Math.PI);
                    }
                    else {
                        ctx.arc(curr.ctrlX * width, curr.ctrlY * height, height * 0.015, 0, 2 * Math.PI);
                    }
                    ctx.fill();
                    ctx.stroke();
                }
            }
        }
    }
}
